const TextInputComponent = {
    templateUrl: '/formViewer/component/textInput/textInput.tpl.html',
    controller: 'textInputController',
    bindings: {
        fieldStructure: '<',
        timeLastModified: '<',
        hideLabel: '<'
    }
};

angular.module('umFormViewer')
    .component('uiTextInput', TextInputComponent);
